(() => {
  if (window.FrostskinProductConfigurator) {
    window.FrostskinProductConfigurator.init(document);
    return;
  }

  const liquidName = 'properties[Cooling Liquid Color]';
  const bagName = 'properties[Waist Bag Color]';
  const uppercase = (value) => String(value || '').trim().toUpperCase();

  function update(options) {
    const liquid = options.querySelector(`input[name="${liquidName}"]:checked`);
    const bag = options.querySelector(`input[name="${bagName}"]:checked`);
    if (!liquid || !bag) return;

    const liquidLabel = liquid.closest('label')?.querySelector('strong')?.textContent.trim() || `${uppercase(liquid.value)} LIQUID`;
    const bagLabel = bag.closest('label')?.querySelector('strong')?.textContent.trim() || `${uppercase(bag.value)} WAIST BAG`;

    options.querySelectorAll('[data-fs-liquid-summary]').forEach((node) => {
      node.textContent = liquidLabel;
    });
    options.querySelectorAll('[data-fs-bag-summary]').forEach((node) => {
      node.textContent = bagLabel;
    });

    const bagPreview = options.querySelector('[data-fs-bag-preview]');
    if (bagPreview && bag.dataset.fsBagImage) {
      bagPreview.src = bag.dataset.fsBagImage;
      bagPreview.alt = bag.dataset.fsBagAlt || bagLabel;
      bagPreview.style.objectFit = bag.dataset.fsBagFit || 'contain';
      bagPreview.style.objectPosition = bag.dataset.fsBagPosition || '50% 50%';
    }
    options.querySelectorAll('[data-fs-bag-caption]').forEach((node) => {
      node.textContent = options.dataset.fsBagCaptionLabel ? `${options.dataset.fsBagCaptionLabel} · ${bagLabel}` : (bag.dataset.fsBagCaptionValue || bagLabel);
    });
  }

  function init(root = document) {
    root.querySelectorAll('.fs-order-options').forEach((options) => {
      if (options.dataset.fsConfiguratorReady === 'true') return;
      options.dataset.fsConfiguratorReady = 'true';
      options.addEventListener('change', () => update(options));
      update(options);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.FrostskinProductConfigurator = { init };
})();
